

class headerSearch{
    constructor(){
        this.parent = document.querySelector('.header-search');
        if(!parent){
            return;
        }
        this.init();
    }
    openSearch = () =>{
        const desktopInput = document.querySelector('.input-header-search');
        this.parent.classList.add('active');
        desktopInput.focus();
    }
    closeSearch = () =>{
        const resultsWrap = document.querySelector('.header-search-result');
        this.parent.classList.remove('active');
        const results = document.querySelector('.header-search-result .search-items');
        const resultCount = document.querySelector('.result-count');
        resultsWrap.classList.remove('active');
        results.innerHTML = "";
        resultCount.innerHTML = "";
        const desktopInput = document.querySelector('.input-header-search');
        if(desktopInput){
            desktopInput.value = "";
        }
    }
    clickEvent = () =>{
        let openSearchBtn = document.querySelector('.search-button');
        if(openSearchBtn){
            openSearchBtn.addEventListener('click',(e)=>{
                e.stopPropagation();
                this.openSearch();
            })
        }
        let closeSearchBtn = this.parent.querySelector('.header-search-close-btn');
        if(closeSearchBtn){
            closeSearchBtn.addEventListener('click',(e)=>{
                this.closeSearch();
            })
        }
        const xsOpenBtn = document.querySelector('.mobile-search-btn');
        xsOpenBtn.addEventListener('click',(e)=>{
            e.stopPropagation();
            this.openSearch();
        })
        document.addEventListener('click',(e)=>{
            this.closeSearch();
        })
        this.parent.addEventListener('click',(e)=>{
            e.stopPropagation();
        })
    }
    changeEvent = () =>{
        const desktopInput = document.querySelector('.input-header-search');
        const resultsWrap = document.querySelector('.header-search-result');
        const results = document.querySelector('.header-search-result .search-items');
        const loader = document.querySelector('.header-search-result .header-search-loader');
        const template = document.querySelector('.desk-header-search-item .product-item');
        const resultCount = document.querySelector('.result-count');
        const viewResultBtn = document.querySelector('.view-all-search-btn');
        // const loader = 
        if(desktopInput){
            desktopInput.addEventListener('input', window.debounceInput(async(value)=>{
                if(value.length > 3){
                    results.innerHTML = "";
                    resultsWrap.classList.add('active');
                    loader.classList.add('active');
                    const data = await this.search(value);
                    const products = data.resources.results.products;
                    const articles = data.resources.results.articles;

                    // let renderItems = [...products]
                    // renderItems = renderItems.length > 0 ? renderItems.splice(0,4) : []
                    products.forEach(async (product,i) => {
                        console.log(product); 
                        const clone = template.cloneNode(true);
                        const {image, price, title, url, handle} = product;
                        const productData =  await fetch(`/products/${handle}.json`);
                        clone.querySelector('.product-item__bg').style.backgroundImage = `url(${image})`;
                        try{
                            const productRes =  await productData.json();
                            if(productRes?.product?.images[1]?.src){
                                clone.querySelector('.product-item__bg__under').style.backgroundImage = `url(${productRes.product.images[1]?.src})`;
                            }else{
                                clone.querySelector('.product-item__bg__under').remove()
                            }
                        }catch(e){

                        }
                        clone.querySelector('.product__grid__title').textContent = title;
                        clone.querySelector('.new-price').textContent = window.formatMoney(price).replace(/((\,00)|(\.00))$/g, '');
                        clone.querySelector('.product-link').href = url;
                        results.appendChild(clone);
                        if(i==3){
                            return;
                        }
                    });
                    
                    loader.classList.remove('active');
                    if(products.length > 0){
                        results.classList.remove('blogs');
                        resultCount.innerHTML = `${products.length} results for <span class="value"> ${value}</span>`;
                        viewResultBtn.href = `/search?q=${value}`;
                        if(window.innerWidth <= 767){
                            viewResultBtn.style['display']= 'block';
                        }
                    }else if(articles.length > 0){
                        resultCount.innerHTML = `${articles.length} results for <span class="value"> ${value}</span>`;
                        viewResultBtn.href = `/search?q=${value}`;
                        if(window.innerWidth <= 767){
                            viewResultBtn.style['display']= 'block';
                        }
                        let bloglinks = document.createElement('ul');
                        bloglinks.classList.add('blog-links-wrap')
                        articles.forEach(async (article,i) => {
                            let li = document.createElement('li');
                            let link = document.createElement('a');
                            link.href = article.url;
                            link.innerHTML = article.title;
                            li.appendChild(link);
                            li.classList.add('blog-link')
                            // `<li><a href="${article.url}">${article.title}</a></li>`
                            bloglinks.appendChild(li);
                        });
                        results.classList.add('blogs');
                        results.appendChild(bloglinks);
                    }else{
                        resultCount.innerHTML = `No results for <span class="value"> ${value}</span>`;
                        viewResultBtn.style['display']= 'none';
                        if(window.innerWidth <= 767){
                            results.innerHTML = `Sorry, nothing found for "${value}"`;
                        }
                    }
                }else{
                    results.innerHTML = "";
                    resultCount.innerHTML = "";
                    resultsWrap.classList.remove('active');
                    viewResultBtn.style['display']= 'none';
                }
            }),500)
        }
    }


    search = async (value) =>{
        try{
            const data = await fetch(`/search/suggest.json?q=${value}&resources[type]=product,article&resources[unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`)
            const res = await data.json();
            return res;
        }catch(e){

        }
    }
    init = () =>{
        this.clickEvent();
        this.changeEvent();
    }
}

new headerSearch();